<template>
  <div style="width: 60%">
    <Icon name="timestop" size="16px" class="mb-0 mr-1 relative" style="top: 3px;"/>
    <span class="caption grey--text text--darken-1">Duração</span>
    <v-layout row align-start class="mt-0" style="width: 70%">
      <v-text-field
        :value="durationHours"
        @input="val => updateDuration(Number(val), durationMinutes || 0)"
        type="number"
        label="Horas"
        persistent-hint
        dense
        solo
        class="thin-border"
      />
      <span class="mx-2 mt-2 pt-1">:</span>
      <v-text-field
        :value="durationMinutes"
        @input="val => updateDuration(durationHours || 0, Number(val))"
        label="Minutos"
        persistent-hint
        dense
        type="number"
        solo
        class="thin-border"
      />
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'AnesthesiaDuration',
  props: {
    durationMinutes: {
      type: Number,
      default: null
    },
    durationHours: {
      type: Number,
      default: null
    }
  },
  methods: {
    updateDuration(h, m) {
      this.$emit('update:durationHours', h)
      this.$emit('update:durationMinutes', m)
    }
  }
}
</script>
